// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popover_class {\n  background-color: #303133 !important;\n  border-color: #303133 !important;\n  max-height: 700px;\n}\n.popover_class .el-popover__title {\n  color: #fff !important;\n  background-color: #303133 !important;\n}\n.popover_class .popper__arrow, .popover_class .popper__arrow::after {\n  border-right-color: #303133 !important;\n}\n", ""]);
// Exports
module.exports = exports;
